// extracted by mini-css-extract-plugin
export default {"device-general-info-panel":"Twci","deviceGeneralInfoPanel":"Twci"};